// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EayEU","content":"styles_content__1zCmN"};